export class ICqmsVisitNoteDetails {
    cqmsVisitId: number;
    patId: number;
    encounterId: string;
    measureId: number;
    qualifyingCode: number;
    qualifyingDescription: string;
    isActive: boolean;
    isPerfomanceMed: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    measureName: String;
    masterMeasureId: number;
    Notes: string;
}